import React, { useState } from "react";
import ExpenseDialog from "../views/ExpenseDialog.jsx";
import axios from "axios";
import { useEffect } from "react";
import SideBar from "./SideBar";
import Swal from "sweetalert2";
import { Button } from "@mantine/core";
import {
  FaCashRegister,
  FaFileMedical,
  FaPenSquare,
  FaPaperPlane,
  FaRegEdit,
  FaRegTrashAlt,
  FaFileExcel,
} from "react-icons/fa";

import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Link } from "react-router-dom";

import useCollapse from "react-collapsed";
import HeaderName from "./HeaderName";
import { useSelector } from "react-redux";
const Income = () => {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  //const url = 'http://localhost:9000/api/'
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const today_date = today.toISOString().split("T")[0];
  console.log(today_date);
  const [hide, setHide] = useState(true);
  const [bcshow, setBCShow] = useState("bankTable");
  const [relatedBranch, setRelatedBranch] = useState([]);
  const [showBranch, setShowBranch] = useState(false);
  const [branchLists, setBranchLists] = useState([]);

  const [isExpanded, setExpanded] = useState(false);
  const [isAccData, setAccData] = useState(false);
  const [relatedLists, setRelatedLists] = useState([]);
  const [isShow, setIsShow] = useState(false);

  const [fromDate, setFromDate] = useState();

  const [toDate, setToDate] = useState();

  const [bankTotal, setBankTotal] = useState(0);
  const [cashTotal, setCashTotal] = useState(0);

  const [bankExpenseList, setBankExpenseList] = useState([]);
  const [cashExpenseList, setCashExpenseList] = useState([]);
  const [bankNameList, setBankNameList] = useState([]);
  const [cashNameList, setCashNameList] = useState([]);
  const [originBankList, setOriginBankList] = useState([]);
  const [originCashList, setOriginCashList] = useState([]);
  const [showOrigin, setShowOrigin] = useState(true);
  const [cashSearchList, setCashSearchList] = useState([]);

  const [show, setShow] = useState("bankTable");
  const [HOshow, setHOShow] = useState("bankHOTable");
  // console.log(HOshow,'Hoh=s')
  const [showFilter, setShowFilter] = useState(false);
  const [branchId, setBranchId] = useState("");
  const [HOCashTotal, setHOCashTotal] = useState("");
  const [branch, setBranch] = useState("");

  const { getCollapseProps, getToggleProps } = useCollapse();
  const [searchList, setSearchList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  const handleDelete = (event) => {
    api
      .delete("expense/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = expenseLists.filter((item) => item._id !== event);
        setExpenseLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleProBranch = async (event) => {
    if (event == "HO") {
      window.location.reload();
    }
    console.log(event, "Branch ID");
    setBranchId(event);
    try {
      Swal.fire({
        title: "Loading",
        text: "Please wait...",
        allowOutsideClick: false,
      });
      await api
        .get(`expenses/filter`, {
          params: { start: fromDate, end: toDate, relatedBranch: event },
        })
        .then((res) => {
          // setAccountLists(res.data.data)
          //setTransactionLists(res.data.transaction)
          console.log(res.data.data, "income list");
          setBankTotal(res.data.data.BankTotal);
          setCashTotal(res.data.data.CashTotal);
          setBankExpenseList(
            res.data.data.BankList.filter((el) => el.relatedBranch)
          );
          setCashExpenseList(
            res.data.data.CashList.filter((el) => el.relatedBranch)
          );
          setBankNameList(
            res.data.data.BankNames.filter((el) => el.relatedBranch)
          );
          setCashNameList(
            res.data.data.CashNames.filter((el) => el.relatedBranch)
          );
          console.log(res.data.data.BankNames, "name");
          //console.log(res.data.transaction)
          setShowFilter(true);
          setShowOrigin(false);
        })
        .catch((error) => {
          console.log("error", error);
        });
      Swal.close();

      // Process the response data
      //console.log(data);
    } catch (error) {
      Swal.close();
      console.error("Error occurred while fetching data.", error);
    }
    // const getRelatedBranch = async () => {
    //   try {
    //     const res = await api.get('incomes')

    //     setRelatedBranch(
    //       res.data.list.filter(
    //         el => (el.relatedBranch ? el.relatedBranch._id : '') == event
    //       )
    //     )
    //   } catch (err) {
    //     alert(err.message)
    //   }
    // }
    // getRelatedBranch()
    // setHide(false)
    // setShowBranch(true)
  };

  const handleAdminChange = () => {
    setExpanded(!isExpanded);
  };

  const handleAccChange = () => {
    setAccData(!isAccData);
  };

  const [expenseLists, setExpenseLists] = useState([]);
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [HObankTotal, setHOBankTotal] = useState("");

  const showDialog = () => setOpen(true);
  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      // console.log(_export.current.props.data,'bank')
      _export.current.props.data.map(function (element, index) {
        element.date = element.date ? element.date.split("T")[0] : "";
      });
      _export.current.save();
    }
  };
  const excelExport1 = () => {
    if (_export.current !== null) {
      // console.log(_export.current.props.data,'cash')
      _export.current.props.data.map(function (element, index) {
        element.date = element.date ? element.date.split("T")[0] : "";
      });
      _export.current.save();
    }
  };

  const excelExport2 = () => {
    if (_export.current !== null) {
      console.log(_export.current.props.data);
      _export.current.props.data.map(function (element, index) {
        element.date = element.date ? element.date.split("T")[0] : "";
      });
      _export.current.save();
    }
  };

  const handleRelatedShow = (val) => {
    const getRelated = async () => {
      try {
        // console.log(val, 'val')
        const res = await api.get("transactions/relatedExpense/" + val);

        // console.log(res.data.data)
        setRelatedLists(res.data.data);
      } catch (err) {}
    };

    getRelated();

    if (isShow) {
      document.getElementById("toggle" + val).removeAttribute("hidden");
    } else {
      document.getElementById("toggle" + val).setAttribute("hidden", "hidden");
    }
    setIsShow(!isShow);
  };

  const handleFilterDate = async () => {
    setShowFilter(true);
    setShowOrigin(false);
    const nDate = new Date(toDate);
    const endDate = nDate.setDate(nDate.getDate() + 1);

    try {
      Swal.fire({
        title: "Loading ...",
        text: "Please Wait !",
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 4000,
      }).then(
        () => {},
        (dismiss) => {
          if (dismiss === "timer") {
            console.log("closed by timer!!!!");
            Swal.fire({
              title: "Finished!",
              type: "success",
              timer: 4000,
              showConfirmButton: false,
            });
          }
        }
      );
      // console.log(branch, 'b id')
      const data = {};
      if (fromDate) data.startDate = fromDate;
      if (endDate) data.endDate = endDate;
      if (branch === "HO") {
      } else {
        data.relatedBranch = branch;
      }

      await api
        .get("expenses/bank-cash-filter/", {
          params: data,
        })
        .then((res) => {
          // setAccountLists(res.data.data)
          //setTransactionLists(res.data.transaction)
          // console.log(res.data.data.CashList, 'date fil')
          // if (fromDate && toDate) {
          //   setShowFilter(false)
          //   setShowOrigin(true)
          // } else {
          //   setShowFilter(true)
          //   setShowOrigin(false)
          // }

          setBankTotal(res.data.data.BankTotal);
          setCashTotal(res.data.data.CashTotal);

          setBankExpenseList(res.data.data.BankList);

          setCashExpenseList(res.data.data.CashList);
          setBankNameList(res.data.data.BankNames);
          setCashNameList(res.data.data.CashNames);
          // console.log(res.data.data, 'b n l')
        })
        .catch((error) => {
          console.log("error", error);
        });
      Swal.close();

      // Process the response data
      //console.log(data);
    } catch (error) {
      Swal.close();
      console.error("Error occurred while fetching data.", error);
    }
  };
  const search = (val) => {
    if (val) {
      setSearchList(
        bankExpenseList.filter(
          (el) =>
            el.relatedBankAccount.name
              .toLowerCase()
              .includes(val.toLowerCase()) ||
            el.relatedAccounting.name.toLowerCase().includes(val.toLowerCase())
        )
      );

      setCashSearchList(
        cashExpenseList.filter(
          (el) =>
            el.relatedCashAccount.name
              .toLowerCase()
              .includes(val.toLowerCase()) ||
            el.relatedAccounting.name.toLowerCase().includes(val.toLowerCase())
        )
      );

      // console.log(bankExpenseList, 'data')

      setShowSearch(true);
      setHide(false);
    } else {
      setShowSearch(false);
      setHide(true);
    }
  };

  useEffect(() => {
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    getBranches();

    const getExpenseLists = async () => {
      try {
        const res = await api.get("/expenses/bank-cash-filter");

        // const result = res.data.list.filter((e) => e.relatedCashAccount.name == 'Cash in Hand-MMK');

        // console.log(res.data.data)
        // console.log();
        setExpenseLists(res.data.data);

        setOriginBankList(
          res.data.data.BankList?.filter(
            (el) => !el.relatedBranch && el.relatedBankAccount
          )
        );

        if (res.data.data) {
          var totalAmount = 0;

          const total = res.data.data.BankList?.filter(
            (el) => !el.relatedBranch && el.relatedBankAccount
          ).map((i) => (totalAmount = totalAmount + i.finalAmount));

          setHOBankTotal(total);
        }

        setOriginCashList(
          res.data.data.CashList?.filter(
            (el) => !el.relatedBranch && el.relatedCashAccount
          )
        );

        if (res.data.data) {
          var totalCAmount = 0;

          const total = res.data.data.CashList?.filter(
            (el) => !el.relatedBranch && el.relatedCashAccount
          ).map((i, index) => (totalCAmount += i.finalAmount));
          console.log(total, "Ctotal");
          setHOCashTotal(total);
        }

        // setFilterDate(res.data.list.map(()))
        // console.log(res.data.list, 'income')
        // console.log(
        //   res.data.list.filter(
        //     el => !el.relatedBranch && el.relatedCashAccount
        //   ),
        //   'c fil'
        // )
        setBankTotal(res.data.data.BankTotal);
        setCashTotal(res.data.data.CashTotal);
      } catch (err) {
        alert(err.message);
      }
    };

    getExpenseLists();
  }, []);

  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active'>Expense List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='row'>
                    <div className='form-group col-md-3'>
                      <label>From</label>
                      <input
                        type='date'
                        name='from'
                        id='from'
                        className='form-control'
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                    <div className='form-group col-md-3'>
                      <label>To</label>
                      <input
                        type='date'
                        name='to'
                        id='to'
                        className='form-control'
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                    <div className='col-md-4' style={{ marginTop: "2.6em" }}>
                      <div className='form-group'>
                        <select
                          name='currency'
                          id=''
                          className='form-control '
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => setBranch(e.target.value)}
                        >
                          <option hidden>Choose Branches</option>
                          <option value='HO'>HO</option>

                          {branchLists.map((option) => (
                            <option value={option._id}>{option.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className='form-group col-md-2'>
                      <button
                        className='btn btn-sm btn-primary form-control'
                        style={{ marginTop: "37px" }}
                        onClick={handleFilterDate}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='row'>
                    <div
                      className='offset-5 col-6 input-group'
                      style={{ marginTop: "28px" }}
                    >
                      <input
                        type='search'
                        className='form-control rounded'
                        id='search_code'
                        placeholder='Search'
                        onChange={(e) => search(e.target.value)}
                      />
                      {/* <button
                        type='button'
                        className='btn btn-outline-primary'
                        style={{ height: '0.97cm', marginTop: '0.2cm' }}
                      >
                        search
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='card'>
                    <div className='card-header'>
                      <div className='d-flex justify-content-between'>
                        <div className=''>
                          <label className=''>Expense Transaction List</label>
                        </div>

                        {showFilter && (
                          <div className='d-flex float-center'>
                            <div className='' style={{ marginRight: "5px" }}>
                              <Button
                                color='cyan'
                                radius='sm'
                                size='sm'
                                onClick={() => setHOShow("bankHOTable")}
                              >
                                Bank ({bankTotal}) MMK
                              </Button>
                            </div>

                            <div className=''>
                              <Button
                                color='cyan'
                                radius='sm'
                                size='sm'
                                onClick={() => setHOShow("cashHOTable")}
                              >
                                Cash ({cashTotal}) MMK
                              </Button>
                            </div>

                            <div className='col-3'>
                              {HOshow == "bankHOTable" ? (
                                <button
                                  type='button'
                                  className='btn btn-sm btn-success'
                                  onClick={excelExport}
                                >
                                  <FaFileExcel />
                                  &nbsp;Export
                                </button>
                              ) : (
                                <button
                                  type='button'
                                  className='btn btn-sm btn-success'
                                  onClick={excelExport1}
                                >
                                  <FaFileExcel />
                                  &nbsp;Export
                                </button>
                              )}
                            </div>
                          </div>
                        )}
                        {showOrigin && (
                          <div className='d-flex col-4 float-center'>
                            <div className='' style={{ marginRight: "5px" }}>
                              <Button
                                color='cyan'
                                radius='sm'
                                size='sm'
                                onClick={() => setHOShow("bankHOTable")}
                              >
                                Bank (0) MMK
                              </Button>
                            </div>

                            <div className=''>
                              <Button
                                color='cyan'
                                radius='sm'
                                size='sm'
                                onClick={() => setHOShow("cashHOTable")}
                              >
                                Cash ({cashTotal}) MMK
                              </Button>
                            </div>
                          </div>
                        )}

                        <span className='float-right'>
                          <button
                            type='button'
                            className='btn btn-sm btn-primary'
                            onClick={showDialog}
                          >
                            <i className='fas fa-plus'></i> Add
                          </button>
                          &nbsp;
                          {/* <a href="/income_type" className="btn btn-primary">
                            Income Type
                          </a> */}
                        </span>
                      </div>
                      <div className='row' id='trial_balance'></div>
                    </div>

                    <div className='card-body'>
                      {/* Export data in Excel */}

                      {HOshow === "bankHOTable" ? (
                        <ExcelExport
                          data={bankExpenseList}
                          ref={_export}
                          fileName='Bank_ExpenseList.xlsx'
                        >
                          <ExcelExportColumn
                            field=''
                            title='No'
                            locked={true}
                            width={30}
                          />
                          <ExcelExportColumn
                            field='date'
                            title='Date'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={200}
                          />
                          <ExcelExportColumn
                            field='relatedAccounting.code'
                            title='Account Code'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={200}
                          />

                          <ExcelExportColumn
                            field='relatedBankAccount.name'
                            title='Bank Account'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={250}
                          />

                          <ExcelExportColumn
                            field='relatedAccounting.name'
                            title='Account'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={450}
                          />
                          <ExcelExportColumn
                            field='finalAmount'
                            title='Balance'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={150}
                          />
                          <ExcelExportColumn
                            field='finalCurrency'
                            title='Currency'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={150}
                          />

                          <ExcelExportColumn
                            field='relatedBranch.name'
                            title='Branch'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={250}
                          />
                          <ExcelExportColumn
                            field='debitVoucherNumber'
                            title='Debit Voucher Number'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={550}
                          />
                          <ExcelExportColumn
                            field='remark'
                            title='Remark'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={550}
                          />
                        </ExcelExport>
                      ) : (
                        <ExcelExport
                          data={cashExpenseList}
                          ref={_export}
                          fileName='Cash_ExpenseList.xlsx'
                        >
                          <ExcelExportColumn
                            field=''
                            title='No'
                            locked={true}
                            width={30}
                          />
                          <ExcelExportColumn
                            field='date'
                            title='Date'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={200}
                          />

                          <ExcelExportColumn
                            field='relatedAccounting.code'
                            title='Account Code'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={200}
                          />

                          <ExcelExportColumn
                            field='relatedCashAccount.name'
                            title='Cash Account'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={250}
                          />

                          <ExcelExportColumn
                            field='relatedAccounting.name'
                            title='Account'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={450}
                          />
                          <ExcelExportColumn
                            field='finalAmount'
                            title='Balance'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={150}
                          />
                          <ExcelExportColumn
                            field='finalCurrency'
                            title='Currency'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={150}
                          />

                          <ExcelExportColumn
                            field='relatedBranch.name'
                            title='Branch'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={150}
                          />
                          <ExcelExportColumn
                            field='debitVoucherNumber'
                            title='Debit Voucher Number'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={550}
                          />
                          {/* <td>{expenseList.debitVoucherNumber}</td> */}
                          <ExcelExportColumn
                            field='remark'
                            title='Remark'
                            headerCellOptions={{
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                            width={550}
                          />
                        </ExcelExport>
                      )}

                      {/* Export Data in Excel end */}
                      <div className='row'>
                        <div className='col-md-12'>
                          <div
                            className='table-responsive text-black'
                            id='slimtest2'
                          >
                            <table
                              className='table table-hover'
                              id='filter_date'
                            >
                              <thead className='ok'>
                                <tr>
                                  <th>#</th>
                                  <th>Code</th>
                                  <th className=''>Date</th>
                                  <th>
                                    {HOshow === "bankHOTable"
                                      ? "Bank Account"
                                      : "Cash Account"}
                                  </th>
                                  <th>Account</th>
                                  <th>Balance</th>
                                  <th>Currency</th>
                                  <th>Branch</th>
                                  <th>Debit Voucher No</th>
                                  <th>Remark</th>
                                  <th className='text-center'>Method</th>
                                  <th className='text-center'>Action</th>
                                </tr>
                              </thead>
                              <tbody className=''>
                                {HOshow === "bankHOTable" &&
                                  hide &&
                                  bankExpenseList.map((expenseList, i) => (
                                    <>
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {expenseList.relatedAccounting
                                            ? expenseList.relatedAccounting.code
                                            : ""}
                                        </td>

                                        <td>
                                          {expenseList.date
                                            ? expenseList.date?.split("T")[0]
                                            : ""}
                                        </td>
                                        <td>
                                          {expenseList.relatedBankAccount
                                            ? expenseList.relatedBankAccount
                                                .name
                                            : expenseList.relatedCashAccount
                                                .name}
                                        </td>
                                        <td>
                                          {expenseList.relatedAccounting.name}
                                        </td>
                                        <td>
                                          {expenseList.finalAmount
                                            ? expenseList.finalAmount.toLocaleString(
                                                undefined,
                                                {
                                                  maximumFractionDigits: 2,
                                                  minimumFractionDigits: 2,
                                                }
                                              )
                                            : ""}
                                        </td>
                                        <td>{expenseList.finalCurrency}</td>
                                        <td>
                                          {expenseList.relatedBranch
                                            ? expenseList.relatedBranch.name
                                            : "HO"}
                                        </td>
                                        <td>
                                          {expenseList?.debitVoucherNumber}
                                        </td>
                                        <td>{expenseList.remark}</td>
                                        <td className='text-center'>
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-primary ml-2'
                                            onClick={() =>
                                              handleRelatedShow(
                                                // expenseList._id,
                                                expenseList._id
                                              )
                                            }
                                          >
                                            Transaction
                                          </button>
                                        </td>

                                        <td>
                                          <Link
                                            to={
                                              "/expense-update/" +
                                              expenseList._id
                                            }
                                            className='btn btn-sm btn-warning'
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className='btn btn-sm btn-danger'
                                            onClick={(e) =>
                                              handleDelete(expenseList._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                          &nbsp;
                                        </td>
                                      </tr>
                                      <tr
                                        className='bg-light'
                                        id={"toggle" + expenseList._id}
                                        hidden
                                      >
                                        <td colspan='12'>
                                          <div>
                                            <div class='row'>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  No
                                                </label>
                                              </div>
                                              <div class='col-md-3'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Account
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Type
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Date
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Amount
                                                </label>
                                              </div>
                                            </div>

                                            {relatedLists
                                              ? relatedLists.map(
                                                  (reList, i) => (
                                                    <div class='row'>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {++i}
                                                        </div>
                                                      </div>
                                                      <div class='col-md-3'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {
                                                            reList
                                                              .relatedAccounting
                                                              .name
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        {reList.type}
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {reList.date
                                                            ? reList.date.split(
                                                                "T"
                                                              )[0]
                                                            : ""}
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {reList.amount}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )
                                              : ""}
                                          </div>
                                        </td>
                                      </tr>
                                    </>
                                  ))}
                                {HOshow === "cashHOTable" &&
                                  hide &&
                                  cashExpenseList.map((expenseList, i) => (
                                    <>
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {expenseList.relatedAccounting
                                            ? expenseList.relatedAccounting.code
                                            : ""}
                                        </td>

                                        <td>
                                          {expenseList.date
                                            ? expenseList.date?.split("T")[0]
                                            : ""}
                                        </td>
                                        <td>
                                          {expenseList.relatedCashAccount
                                            ? expenseList.relatedCashAccount
                                                .name
                                            : ""}
                                        </td>
                                        <td>
                                          {expenseList.relatedAccounting.name}
                                        </td>
                                        <td>
                                          {expenseList.finalAmount
                                            ? expenseList.finalAmount.toLocaleString(
                                                undefined,
                                                {
                                                  maximumFractionDigits: 2,
                                                  minimumFractionDigits: 2,
                                                }
                                              )
                                            : ""}
                                        </td>
                                        <td>{expenseList.finalCurrency}</td>
                                        <td>
                                          {expenseList.relatedBranch
                                            ? expenseList.relatedBranch.name
                                            : "HO"}
                                        </td>
                                        <td>
                                          {expenseList?.debitVoucherNumber}
                                        </td>
                                        <td>{expenseList.remark}</td>
                                        <td className='text-center'>
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-primary ml-2'
                                            onClick={() =>
                                              handleRelatedShow(
                                                // expenseList._id,
                                                expenseList._id
                                              )
                                            }
                                          >
                                            Transaction
                                          </button>
                                        </td>

                                        <td>
                                          <Link
                                            to={
                                              "/expense-update/" +
                                              expenseList._id
                                            }
                                            className='btn btn-sm btn-warning'
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className='btn btn-sm btn-danger'
                                            onClick={(e) =>
                                              handleDelete(expenseList._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                          &nbsp;
                                        </td>
                                      </tr>
                                      <tr
                                        className='bg-light'
                                        id={"toggle" + expenseList._id}
                                        hidden
                                      >
                                        <td colspan='12'>
                                          <div>
                                            <div class='row'>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  No
                                                </label>
                                              </div>
                                              <div class='col-md-3'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Account
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Type
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Date
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Amount
                                                </label>
                                              </div>
                                            </div>

                                            {relatedLists
                                              ? relatedLists.map(
                                                  (reList, i) => (
                                                    <div class='row'>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {++i}
                                                        </div>
                                                      </div>
                                                      <div class='col-md-3'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {
                                                            reList
                                                              .relatedAccounting
                                                              .name
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        {reList.type}
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {reList.date
                                                            ? reList.date.split(
                                                                "T"
                                                              )[0]
                                                            : ""}
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {reList.amount}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )
                                              : ""}
                                          </div>
                                        </td>
                                      </tr>
                                    </>
                                  ))}

                                {show === "bankTable" &&
                                  showSearch &&
                                  searchList.map((expenseList, i) => (
                                    <>
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {expenseList.code
                                            ? expenseList.code
                                            : ""}
                                        </td>

                                        <td>
                                          {expenseList.code
                                            ? expenseList.code
                                            : ""}
                                        </td>

                                        <td>
                                          {expenseList.date
                                            ? expenseList.date.split("T")[0]
                                            : ""}
                                        </td>
                                        <td>
                                          {expenseList.relatedBankAccount
                                            ? expenseList.relatedBankAccount
                                                .name
                                            : ""}
                                        </td>
                                        <td>
                                          {expenseList.relatedAccounting.name}
                                        </td>
                                        <td>
                                          {expenseList.finalAmount
                                            ? expenseList.finalAmount.toLocaleString(
                                                undefined,
                                                {
                                                  maximumFractionDigits: 2,
                                                  minimumFractionDigits: 2,
                                                }
                                              )
                                            : ""}
                                        </td>
                                        <td>{expenseList.finalCurrency}</td>
                                        <td>
                                          {expenseList.relatedBranch
                                            ? expenseList.relatedBranch.name
                                            : "HO"}
                                        </td>
                                        <td>
                                          {expenseList?.debitVoucherNumber}
                                        </td>
                                        <td>{expenseList.remark}</td>
                                        <td className='text-center'>
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-primary ml-2'
                                            onClick={() =>
                                              handleRelatedShow(
                                                // expenseList._id,
                                                expenseList._id
                                              )
                                            }
                                          >
                                            Transaction
                                          </button>
                                        </td>

                                        <td>
                                          <Link
                                            to={
                                              "/expense-update/" +
                                              expenseList._id
                                            }
                                            className='btn btn-sm btn-warning'
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className='btn btn-sm btn-danger'
                                            onClick={(e) =>
                                              handleDelete(expenseList._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                          &nbsp;
                                        </td>
                                      </tr>
                                      <tr
                                        className='bg-light'
                                        id={"toggle" + expenseList._id}
                                        hidden
                                      >
                                        <td colspan='12'>
                                          <div>
                                            <div class='row'>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  No
                                                </label>
                                              </div>
                                              <div class='col-md-3'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Account
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Type
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Date
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Amount
                                                </label>
                                              </div>
                                            </div>

                                            {relatedLists
                                              ? relatedLists.map(
                                                  (reList, i) => (
                                                    <div class='row'>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {++i}
                                                        </div>
                                                      </div>
                                                      <div class='col-md-3'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {
                                                            reList
                                                              .relatedAccounting
                                                              .name
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        {reList.type}
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {
                                                            reList.date.split(
                                                              "T"
                                                            )[0]
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {reList.amount}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )
                                              : ""}
                                          </div>
                                        </td>
                                      </tr>
                                    </>
                                  ))}
                                {show === "cashTable" &&
                                  showSearch &&
                                  cashSearchList.map((expenseList, i) => (
                                    <>
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {expenseList.code
                                            ? expenseList.code
                                            : ""}
                                        </td>

                                        <td>
                                          {expenseList.date
                                            ? expenseList.date.split("T")[0]
                                            : ""}
                                        </td>
                                        <td>
                                          {expenseList.relatedCashAccount
                                            ? expenseList.relatedCashAccount
                                                .name
                                            : ""}
                                        </td>
                                        <td>
                                          {expenseList.relatedAccounting.name}
                                        </td>
                                        <td>
                                          {expenseList.finalAmount
                                            ? expenseList.finalAmount.toLocaleString(
                                                undefined,
                                                {
                                                  maximumFractionDigits: 2,
                                                  minimumFractionDigits: 2,
                                                }
                                              )
                                            : ""}
                                        </td>
                                        <td>{expenseList.finalCurrency}</td>
                                        <td>
                                          {expenseList.relatedBranch.name}
                                        </td>
                                        <td>
                                          {expenseList?.debitVoucherNumber}
                                        </td>
                                        <td>{expenseList.remark}</td>
                                        <td className='text-center'>
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-primary ml-2'
                                            onClick={() =>
                                              handleRelatedShow(
                                                // expenseList._id,
                                                expenseList.relatedAccounting
                                                  ._id
                                              )
                                            }
                                          >
                                            Transaction
                                          </button>
                                        </td>

                                        <td>
                                          <Link
                                            to={
                                              "/bank-update/" + expenseList._id
                                            }
                                            className='btn btn-sm btn-warning'
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className='btn btn-sm btn-danger'
                                            onClick={(e) =>
                                              handleDelete(expenseList._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                          &nbsp;
                                        </td>
                                      </tr>
                                      <tr
                                        className='bg-light'
                                        id={"toggle" + expenseList._id}
                                        hidden
                                      >
                                        <td colspan='12'>
                                          <div>
                                            <div class='row'>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  No
                                                </label>
                                              </div>
                                              <div class='col-md-3'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Account
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Type
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Date
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Amount
                                                </label>
                                              </div>
                                            </div>

                                            {relatedLists
                                              ? relatedLists.map(
                                                  (reList, i) => (
                                                    <div class='row'>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {++i}
                                                        </div>
                                                      </div>
                                                      <div class='col-md-3'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {
                                                            reList
                                                              .relatedAccounting
                                                              .name
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        {reList.type}
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {
                                                            reList.date.split(
                                                              "T"
                                                            )[0]
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          {reList.amount}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )
                                              : ""}
                                          </div>
                                        </td>
                                      </tr>
                                    </>
                                  ))}
                              </tbody>
                              {/* {showBranch &&
                                relatedBranch.map((incomeList, i) => (
                                  <tbody className=''>
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {incomeList.date
                                          ? incomeList.date.split('T')[0]
                                          : ''}
                                      </td>
                                      <td>
                                        {incomeList.relatedBankAccount
                                          ? incomeList.relatedBankAccount.name
                                          : incomeList.relatedCashAccount.name}
                                      </td>
                                      <td>
                                        {incomeList.relatedAccounting.name}
                                      </td>
                                      <td>
                                        {incomeList.finalAmount
                                          ? incomeList.finalAmount.toLocaleString(
                                              undefined,
                                              {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                              }
                                            )
                                          : ''}
                                      </td>
                                      <td>{incomeList.finalCurrency}</td>
                                      <td>{incomeList.relatedBranch.name}</td>

                                      <td>{incomeList.remark}</td>
                                      <td className='text-center'>
                                        <button
                                          type='button'
                                          className='btn btn-sm btn-primary ml-2'
                                          onClick={() =>
                                            handleRelatedShow(
                                              incomeList._id,
                                              incomeList.relatedAccounting._id
                                            )
                                          }
                                        >
                                          Transaction
                                        </button>
                                      </td>

                                      <td>
                                        <Link
                                          to={'/bank-update/' + incomeList._id}
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </Link>
                                        &nbsp;
                                        <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e =>
                                            handleDelete(incomeList._id)
                                          }
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                        &nbsp;
                                      </td>
                                    </tr>

                                    <tr
                                      className='bg-light'
                                      id={'toggle' + incomeList._id}
                                      hidden
                                    >
                                      <td colspan='12'>
                                        <div>
                                          <div class='row'>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                No
                                              </label>
                                            </div>
                                            <div class='col-md-3'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Account
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Type
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Date
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Amount
                                              </label>
                                            </div>
                                          </div>

                                          {relatedLists
                                            ? relatedLists.map((reList, i) => (
                                                <div class='row'>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {++i}
                                                    </div>
                                                  </div>
                                                  <div class='col-md-3'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {
                                                        reList.relatedAccounting
                                                          .name
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class='col-md-2'>
                                                    {reList.type}
                                                  </div>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {
                                                        reList.date.split(
                                                          'T'
                                                        )[0]
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {reList.amount}
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            : ''}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                ))}

                              {hide &&
                                incomeLists.map((incomeList, i) => (
                                  <tbody className=''>
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {incomeList.date
                                          ? incomeList.date.split('T')[0]
                                          : ''}
                                      </td>
                                      <td>
                                        {incomeList.relatedBankAccount
                                          ? incomeList.relatedBankAccount.name
                                          : incomeList.relatedCashAccount.name}
                                      </td>
                                      <td>
                                        {incomeList.relatedAccounting.name}
                                      </td>
                                      <td>
                                        {incomeList.finalAmount
                                          ? incomeList.finalAmount.toLocaleString(
                                              undefined,
                                              {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                              }
                                            )
                                          : ''}
                                      </td>
                                      <td>{incomeList.finalCurrency}</td>
                                      <td>{incomeList.relatedBranch.name}</td>

                                      <td>{incomeList.remark}</td>
                                      <td className='text-center'>
                                        <button
                                          type='button'
                                          className='btn btn-sm btn-primary ml-2'
                                          onClick={() =>
                                            handleRelatedShow(
                                              incomeList._id,
                                              incomeList.relatedAccounting._id
                                            )
                                          }
                                        >
                                          Transaction
                                        </button>
                                      </td>

                                      <td>
                                        <Link
                                          to={
                                            '/income-update/' + incomeList._id
                                          }
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </Link>
                                        &nbsp;
                                        <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e =>
                                            handleDelete(incomeList._id)
                                          }
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                        &nbsp;
                                      </td>
                                    </tr>

                                    <tr
                                      className='bg-light'
                                      id={'toggle' + incomeList._id}
                                      hidden
                                    >
                                      <td colspan='12'>
                                        <div>
                                          <div class='row'>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                No
                                              </label>
                                            </div>
                                            <div class='col-md-3'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Account
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Type
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Date
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Amount
                                              </label>
                                            </div>
                                          </div>

                                          {relatedLists
                                            ? relatedLists.map((reList, i) => (
                                                <div class='row'>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {++i}
                                                    </div>
                                                  </div>
                                                  <div class='col-md-3'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {
                                                        reList.relatedAccounting
                                                          .name
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class='col-md-2'>
                                                    {reList.type}
                                                  </div>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {
                                                        reList.date.split(
                                                          'T'
                                                        )[0]
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {reList.amount}
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            : ''}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>

                                ))}
                              {showSearch &&
                                searchList.map((incomeList, i) => (
                                  <tbody className=''>
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {incomeList.date
                                          ? incomeList.date.split('T')[0]
                                          : ''}
                                      </td>
                                      <td>
                                        {incomeList.relatedBankAccount
                                          ? incomeList.relatedBankAccount.name
                                          : incomeList.relatedCashAccount.name}
                                      </td>
                                      <td>
                                        {incomeList.relatedAccounting.name}
                                      </td>
                                      <td>
                                        {incomeList.finalAmount
                                          ? incomeList.finalAmount.toLocaleString(
                                              undefined,
                                              {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                              }
                                            )
                                          : ''}
                                      </td>
                                      <td>{incomeList.finalCurrency}</td>
                                      <td>{incomeList.relatedBranch.name}</td>

                                      <td>{incomeList.remark}</td>
                                      <td className='text-center'>
                                        <button
                                          type='button'
                                          className='btn btn-sm btn-primary ml-2'
                                          onClick={() =>
                                            handleRelatedShow(
                                              incomeList._id,
                                              incomeList.relatedAccounting._id
                                            )
                                          }
                                        >
                                          Transaction
                                        </button>
                                      </td>

                                      <td>
                                        <Link
                                          to={
                                            '/income-update/' + incomeList._id
                                          }
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </Link>
                                        &nbsp;
                                        <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e =>
                                            handleDelete(incomeList._id)
                                          }
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                        &nbsp;
                                      </td>
                                    </tr>

                                    <tr
                                      className='bg-light'
                                      id={'toggle' + incomeList._id}
                                      hidden
                                    >
                                      <td colspan='12'>
                                        <div>
                                          <div class='row'>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                No
                                              </label>
                                            </div>
                                            <div class='col-md-3'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Account
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Type
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Date
                                              </label>
                                            </div>
                                            <div class='col-md-2'>
                                              <label
                                                style={{ fontSize: '15px' }}
                                                class='text-dark'
                                              >
                                                Amount
                                              </label>
                                            </div>
                                          </div>

                                          {relatedLists
                                            ? relatedLists.map((reList, i) => (
                                                <div class='row'>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {++i}
                                                    </div>
                                                  </div>
                                                  <div class='col-md-3'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {
                                                        reList.relatedAccounting
                                                          .name
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class='col-md-2'>
                                                    {reList.type}
                                                  </div>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {
                                                        reList.date.split(
                                                          'T'
                                                        )[0]
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class='col-md-2'>
                                                    <div
                                                      style={{
                                                        fontSize: '15px'
                                                      }}
                                                    >
                                                      {reList.amount}
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            : ''}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                ))}

                                ))} */}
                            </table>
                          </div>
                          {showFilter && (
                            <div className='d-flex '>
                              <div style={{ marginRight: "100px" }}>
                                <p>
                                  <b>
                                    <u>Bank List</u>
                                  </b>
                                </p>
                                {Object.entries(bankNameList).map(([k, v]) => (
                                  <p>
                                    {k} : {v}{" "}
                                  </p>
                                ))}
                              </div>

                              <div>
                                <p>
                                  <b>
                                    <u>Cash List</u>
                                  </b>
                                </p>
                                {Object.entries(cashNameList).map(([k, v]) => (
                                  <p>
                                    {k} : {v}{" "}
                                  </p>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ExpenseDialog
                open={open}
                close={() => setOpen(false)}
                setExpenseLists={setExpenseLists}
                expenseLists={expenseLists}
              />
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer'>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default Income;
